import { inject } from '@angular/core';
import { ActivityEntityName, BILL_EXPORT_CSV_COMMAND_ID, BillCsvExport, FinanceSecurityRight } from '@jms/model';
import { extractDownloadErrorMessage } from '@jms/utils/util.download';
import { RightsService } from '@jms/utils/util.permissions';
import { EntityDataService } from '@workbuddy/services/entities';
import { Command } from '@workbuddy/ui/model';
import { ToastService } from '@workbuddy/ui/services';
import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import { saveAs } from 'file-saver';
import { openBillExportDialog } from '../surface/export/bill.export.surface';

export function billExportCommands(): Command[] {

  if (!inject(RightsService).hasRights(FinanceSecurityRight.CanAccessBills)) return [];

  const data = inject(EntityDataService);
  const toast = inject(ToastService);
  const dialogs = inject(WorkBuddyDialogService);
  return [new Command({
    _id: 'bill.export-csv',
    label: 'Export',
    iconLeft: 'fa-regular fa-file-csv',
    action: async () => {
      try {
        const request = await openBillExportDialog(dialogs);
        if (!request) return;
        const result = await data.executeCommand<BillCsvExport>(ActivityEntityName.Bill, BILL_EXPORT_CSV_COMMAND_ID, request);
        saveAs(new Blob([result.content], { type: result.contentType }), result.filename);
      } catch (error) {
        toast.error('Bills', await extractDownloadErrorMessage(error, 'Unable to export Bills'));
      }
    },
  })];
}
